/**
 * Arduino Cart helper 
 */

(function() {

    function onCartChangeHandle(event) {
        const totalQuantity = event.detail.items.reduce((sum, item) => sum + item.quantity, 0);
        const counters = document.querySelectorAll('.ino-menu__cart-counter');

        counters.forEach(element => {
            if(totalQuantity > 0) {
                if(!element.classList.contains('visible')) {
                    element.classList.add('visible');
                }
            } else {
                if(element.classList.contains('visible')) {
                    element.classList.remove('visible');
                }
            }

            element.textContent = totalQuantity;
        });
    }

    // monster cart update event
    document.addEventListener('cart:updated', onCartChangeHandle);

    // empire theme cart update event
    window.addEventListener('cartcount:update', onCartChangeHandle);
    window.addEventListener('cartcount:update', () => {
        monster_refresh(true); // refreshes and opens the cart
    });

})();